<template>
  <div id='app'>
    <transition name='fade' mode='out-in'>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import router from '@/router'

export default {
  name: 'app',
  data: function () {
    return {
      curerntPath: ""
    }
  },
  mounted: function () {

    let self = this
    router.beforeEach((to, from, next) => {  
      self.curerntPath = from.path
      next()
    })

    //ブラウザの戻るイベントの際の処理
    let targetPath = ["/questionDetail", "/questionAnswer", "/questionResult", "/questionResultPerfect"]
    $(window).on("popstate", function (event) {
//alert("popstate")
      if (targetPath.indexOf(self.curerntPath) >= 0) {
        setTimeout(function(){
          router.go(1)
        },200)
      }
    })

  }
}
</script>

<style>

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s
}
.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/App.vue